<template>
    <h3 class="m-1"><b>Events</b></h3>
    <hr/>
    <p-timeline :value="events" align="alternate" >
        <template #marker="slotProps">
            <span class="time-event" :style="{ background: getBg(slotProps.item) }">
                <i class="pi" :class="getIcon(slotProps.item)"></i>
            </span>
        </template>
        <template #content="slotProps">
            <p-card >
                <template #title>
                    <h4>{{ slotProps.item.input_event ? "Data Update" : "Review"  }} Event</h4>
                    <small v-if="slotProps.item.restore">Restored</small>
                    <small v-else-if="slotProps.item.approve">Approved</small>
                    <small v-else-if="slotProps.item.rejected">Rejected</small>
                    <small v-else-if="slotProps.item.input_event">Edit</small>
                    <small v-else>Need information</small>
                </template>
                
                    <template #content>
                    <hr/>
                    <ul style="text-align:left;width:100%;">
                        <li>Username: {{ slotProps.item.username }}</li>
                        <li>Date: {{ (new Date(slotProps.item.date)).toLocaleString("en-IN")   }}</li>
                        <li v-if="slotProps.item.stage">Stage: {{ slotProps.item.stage   }}</li>
                        <li>Role: {{ slotProps.item.role   }}</li>
                        <li v-if="slotProps.item.remarks?.length">
                            Remarks: {{ slotProps.item.remarks   }}</li>
                        <li v-if="slotProps.item.rev_number">
                            Revision Number: {{ slotProps.item.rev_number  }}
                        </li>
                    </ul>
                </template>
            </p-card>
        </template>
    </p-timeline>
</template>
  
<script lang="ts">
  import { base } from "@/misc/base";
import { Options } from "vue-class-component";
  
  @Options({
    props: {
      id: String,
    },
  })
  export default class TimeLine extends base {
    id!: any;
    events = []

    mounted(){

        this.loadSigns()
    }

    async loadSigns(){
        const service = this.store.state.simforce

        service.get(
            `/signature/${this.id}`,
        ).then(res => {
            let events : any = res.data
            events.sort((a : any, b : any ) => (new Date(b.date)).getTime() - (new Date(a.date)).getTime() )
            this.events = events
        }).catch( err => {
            console.log(err)
        })
    }

    getBg(item : any){

        if(item.restore)
            return "orange"

        if(item.approve)
            return "green"

        if(item.rejected)
            return "red"

        return "#3E78BC"
    }
    getIcon(item : any){
        
        if(item.restore){
            return "pi-undo"
        }

        if(item.rejected){
            return "pi-times-circle"
        }

        if(item.approve)
            return  'pi-check-circle'

        if(item.remarks?.length){
            return "pi-bell"
        }

        return 'pi-pencil' 
    }
  }

  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    h4,small {
        text-align:left;
        margin:0;
        text-transform: uppercase;
    }

    small {
        float:left;
        color:#333 !important;
    }

    .pi {
        font-size: 18px;
        position: relative;
        left: 9px;
        top: 8px;
    }

    .time-event {
        background: rgb(62, 120, 188);
        width: 35px;
        height: 35px;
        border-radius: 50%;
        color: #fff;
    }
  </style>